import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../common-component/navbar/Navbar";
import LeftSection from "../common-component/left-menu-section/LeftSection";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BACKEND_URL } from "../common/Common";
import "../userprofile/UserProfile.css"
import { FeedMediaContent, useMediaHeight, MediaType } from "../home/FeedMediaContent .js";
import Hls from "hls.js";
import Slider from "react-slick";

// Images for no data
import nopost from "../../assets/vendordetails/nopost.png";

// Post icons
import threedot from '../../assets/home-images/mid-section-images/threedot.png';
import videomute from "../../assets/home-images/mid-section-images/videomute.png";
import videounmute from "../../assets/home-images/mid-section-images/videounmute.png";
import hearticon from '../../assets/home-images/mid-section-images/hearticon.png';
import commenticon from '../../assets/home-images/mid-section-images/commenticon.png';
import shareicon from '../../assets/home-images/mid-section-images/shareicon.png';
import save from '../../assets/home-images/save.png';
import noreviews from "../../assets/home-images/noreviews.png";
import noactivities from "../../assets/home-images/noactivities.png";
import leftarrow from '../../assets/offers/leftarrow.png';
import popup_yatch from "../../assets/offers/popup_yatch.png";
import xmark from '../../assets/home-images/right-section-images/xmark.png';

//rightsection images
import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';

// Helper function to detect if text is Arabic
const isArabic = (text) => {
    if (!text) return false;
    const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    return arabicPattern.test(text);
};

// Translation cache to store already translated text
const translationCache = new Map();

// Frontend translation function using Google Translate free API
const translateText = async (text, targetLang = 'en') => {
    try {
        // Check cache first
        const cacheKey = `${text}_${targetLang}`;
        if (translationCache.has(cacheKey)) {
            console.log("Translation from cache");
            return translationCache.get(cacheKey);
        }

        // Detect source language (Arabic = 'ar')
        const sourceLang = isArabic(text) ? 'ar' : 'auto';

        // Google Translate free API endpoint
        const translateUrl = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`;

        // Try multiple CORS proxy services in parallel
        const proxyServices = [
            `https://api.allorigins.win/raw?url=${encodeURIComponent(translateUrl)}`,
            `https://api.allorigins.win/get?url=${encodeURIComponent(translateUrl)}`,
            `https://corsproxy.io/?${encodeURIComponent(translateUrl)}`,
        ];

        // Helper function to parse Google Translate response
        const parseTranslation = (data) => {
            let translated = '';
            let responseData = data;

            if (data.contents) {
                try {
                    responseData = JSON.parse(data.contents);
                } catch (e) {
                    responseData = data;
                }
            }

            if (Array.isArray(responseData) && Array.isArray(responseData[0])) {
                translated = responseData[0]
                    .map(segment => segment && Array.isArray(segment) && segment[0] ? segment[0] : '')
                    .join('')
                    .trim();
            }
            return translated;
        };

        // Try all proxies in parallel
        const proxyPromises = proxyServices.map((proxyUrl, index) => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);

            return fetch(proxyUrl, {
                method: 'GET',
                signal: controller.signal,
                headers: {
                    'Accept': 'application/json',
                }
            })
                .then(response => {
                    clearTimeout(timeoutId);
                    if (response.ok) {
                        return response.json().then(data => ({ data, index }));
                    }
                    throw new Error(`Proxy ${index + 1} returned ${response.status}`);
                })
                .catch(error => {
                    clearTimeout(timeoutId);
                    if (error.name !== 'AbortError') {
                        console.warn(`Proxy ${index + 1} failed:`, error.message);
                    }
                    throw error;
                });
        });

        try {
            const results = await Promise.allSettled(proxyPromises);

            for (const result of results) {
                if (result.status === 'fulfilled') {
                    const { data, index } = result.value;
                    const translated = parseTranslation(data);

                    if (translated && translated !== text && translated.length > 0) {
                        translationCache.set(cacheKey, translated);
                        console.log(`Translation successful using proxy ${index + 1}`);
                        return translated;
                    }
                }
            }
        } catch (raceError) {
            console.warn("All parallel requests failed, trying sequential fallback");
        }

        // Fallback: Try proxies sequentially
        for (let i = 0; i < proxyServices.length; i++) {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 5000);

                const response = await fetch(proxyServices[i], {
                    method: 'GET',
                    signal: controller.signal,
                    headers: {
                        'Accept': 'application/json',
                    }
                });

                clearTimeout(timeoutId);

                if (response.ok) {
                    const responseData = await response.json();
                    const translated = parseTranslation(responseData);

                    if (translated && translated !== text && translated.length > 0) {
                        translationCache.set(cacheKey, translated);
                        console.log(`Translation successful using proxy ${i + 1} (fallback)`);
                        return translated;
                    }
                }
            } catch (proxyError) {
                if (proxyError.name !== 'AbortError') {
                    console.warn(`Proxy ${i + 1} failed:`, proxyError.message);
                }
                continue;
            }
        }

        throw new Error("Translation failed - all proxy services unavailable.");
    } catch (error) {
        console.error("Translation error:", error);
        throw error;
    }
};

// Helper function to calculate discount text
const getDiscountText = (item, className = "offer-tag") => {
    switch (item.discount_type_id) {
        case 8:
        case 4:
            return <span className={className}>{item.discount_type}</span>;
        case 7:
            return (
                <span className={className}>
                    {item.discount_value ? `${item.discount_value}% OFF` : item.discount_type}
                </span>
            );
        case 5:
            return (
                <span className={className}>
                    Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}
                </span>
            );
        case 1:
            return item.discount_value && item.discount_price && item.coupon_price ? (
                <>
                    <span className="old-price">AED {item.coupon_price}</span>
                    <span className="new-price">AED {item.discount_price}</span>
                    <span className="separator">|</span>
                    <span className={className}>{item.discount_value}% OFF</span>
                </>
            ) : (
                <span className={className}>AED {item.coupon_price}</span>
            );
        case 10:
            return className === "limited-deals-tag" ? (
                <span className={className}>From AED {item.coupon_price}</span>
            ) : (
                <span className="discount_type_from">
                    From <span className="discount_coupon_price">AED {item.coupon_price}</span>
                </span>
            );
        default:
            return item.discount_type === "Total" ? (
                <span className={className}>{item.discount_value}% OFF</span>
            ) : (
                <span className={className}>{item.discount_type}</span>
            );
    }
};

// Coupon Card Component
const CouponCard = ({ coupon, isOverlay = false, categoryId = '' }) => {
    if (!coupon) return null;

    return (
        <Link
            to={`/offers/${coupon.coupon_id}/${coupon.category_id || categoryId || 0}`}
            className={`review-post-coupon-card ${isOverlay ? 'review-post-coupon-overlay' : 'review-post-coupon-inline'}`}
        >
            <div className="review-post-coupon-content">
                <div className="review-post-coupon-image">
                    <img
                        src={coupon.coupon_image}
                        alt={coupon.coupon_title || "Coupon"}
                        loading="lazy"
                        onError={(e) => {
                            e.target.src = "/no-image.png";
                        }}
                    />
                </div>
                <div className="review-post-coupon-info">
                    <h4 className="review-post-coupon-title">{coupon.coupon_title}</h4>
                    <p className="review-post-coupon-location">{coupon.location}</p>
                    <div className="review-post-coupon-discount">
                        {getDiscountText(coupon, "review-post-coupon-discount-tag")}
                    </div>
                </div>
            </div>
        </Link>
    );
};

// Hook to detect mobile and tablet
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};

// Review Image Slider Component
const ReviewImageSlider = ({ post, activeSlide, sliderSettings, coupons = [], categoryId = '' }) => {
    const isMobile = useIsMobile();

    // Determine media type and dimensions
    const hasMultipleImages = post.post_images && post.post_images.length > 1;
    const hasSingleImage = post.post_images &&
        post.post_images.length === 1 &&
        post.post_images[0].post_images;

    let mediaType, mediaHeight, mediaWidth;

    if (hasMultipleImages) {
        mediaType = MediaType.MULTI_POST;
        const firstImage = post.post_images[0];
        mediaHeight = firstImage.height;
        mediaWidth = firstImage.width;
    } else if (hasSingleImage) {
        mediaType = MediaType.IMAGE;
        const image = post.post_images[0];
        mediaHeight = image.height;
        mediaWidth = image.width;
    }

    // Use the same height calculation hook as FeedMediaContent
    const calculatedHeight = useMediaHeight(mediaHeight, mediaWidth, mediaType);

    // Check if original height > 1024px (tall image)
    const isTallMedia = mediaHeight && mediaHeight > 1024;

    // Check if this is view_type 12 (review with image)
    const isViewType12 = post.view_type === 12;

    // For mobile and tablet: use cover and no black background
    // For desktop/webview: use contain for tall media or view_type 12 with black background
    const objectFit = isMobile
        ? 'cover'
        : (isTallMedia || isViewType12 ? 'contain' : 'cover');
    const backgroundColor = isMobile ? 'transparent' : ((isTallMedia || isViewType12) ? '#000' : 'transparent');

    if (hasMultipleImages) {
        return (
            <div
                className="multi-post-image"
                style={{
                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                    backgroundColor: backgroundColor,
                    position: 'relative',
                    width: '100%'
                }}
            >
                <div className="image-counter">
                    {activeSlide + 1} / {post.post_images.length}
                </div>
                <Slider {...sliderSettings} style={{ height: '100%' }}>
                    {post.post_images.map((img, idx) => {
                        const imgIsTall = img.height && img.height > 1024;
                        const imgObjectFit = isMobile ? 'cover' : ((imgIsTall || isViewType12) ? 'contain' : 'cover');
                        const imgBackgroundColor = isMobile ? 'transparent' : ((imgIsTall || isViewType12) ? '#000' : 'transparent');
                        return (
                            <div
                                className="slide-wrapper"
                                key={idx}
                                style={{
                                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                                    width: '100%',
                                    backgroundColor: imgBackgroundColor
                                }}
                            >
                                <img
                                    src={img.post_images}
                                    alt={`Post ${post.id} Image ${idx + 1}`}
                                    className="review-image-content"
                                    style={{
                                        width: '100%',
                                        height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                                        objectFit: imgObjectFit,
                                        display: 'block',
                                        backgroundColor: imgBackgroundColor
                                    }}
                                />
                            </div>
                        );
                    })}
                </Slider>
                {/* Fixed coupon overlay */}
                {coupons && coupons.length > 0 && (
                    <div className="review-post-coupon-overlay-container review-post-coupon-fixed-overlay">
                        {coupons.map((coupon, couponIdx) => (
                            <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={categoryId} />
                        ))}
                    </div>
                )}
            </div>
        );
    } else if (hasSingleImage) {
        return (
            <div
                style={{
                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                    backgroundColor: backgroundColor,
                    position: 'relative',
                    width: '100%',
                    overflow: 'hidden'
                }}
            >
                <img
                    src={post.post_images[0].post_images}
                    alt={`Post ${post.id} Image`}
                    className="review-image-content"
                    style={{
                        width: '100%',
                        height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                        objectFit: objectFit,
                        display: 'block'
                    }}
                />
                {/* Coupon overlay */}
                {coupons && coupons.length > 0 && (
                    <div className="review-post-coupon-overlay-container">
                        {coupons.map((coupon, couponIdx) => (
                            <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={categoryId} />
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return null;
};

const UserProfile = () => {
    const { user_id } = useParams();
    const navigate = useNavigate();

    const [userdetails, setUserDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [postsLoading, setPostsLoading] = useState(false);
    const [showFullBio, setShowFullBio] = useState(false);
    const [activeTab, setActiveTab] = useState("Posts");
    const [userpostlist, setUserpostlist] = useState([]);
    const [userreviewslist, setUserreviewslist] = useState([]);
    const [useractivitieslist, setUseractivitieslist] = useState([]);
    const [activeSlide, setActiveSlide] = useState(0);
    const [globalMute, setGlobalMute] = useState(true);
    const [expand, setExpand] = useState({});
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [reviewExpand, setReviewExpand] = useState({});
    const [reviewTextOverflow, setReviewTextOverflow] = useState({});
    const [translatedTexts, setTranslatedTexts] = useState({});
    const [isTranslated, setIsTranslated] = useState({});
    const [isTranslating, setIsTranslating] = useState({});
    const [followingcount, setFollowingCount] = useState(0);
    const [connectioncount, setConnectionCount] = useState(0);
    const [downloadPopupOpen, setDownloadPopupOpen] = useState(false);

    // Detect mobile view
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchuserdetails = async () => {
        if (!user_id) return;

        try {
            setLoading(true);
            console.log("Vendor ID:", user_id);

            const response = await axios.post(`${BACKEND_URL}website/get-vendor-details`,
                { id: user_id }
            );

            setUserDetails([response.data]);

        } catch (error) {
            console.error("Error fetching vendor details:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchFollowingCount = async () => {
        if (!user_id) return;

        try {
            const response = await axios.get(`${BACKEND_URL}website/get-following-user-list`, {
                params: {
                    login_user_id: 325,
                    user_id: user_id
                }
            });


            // Handle different possible response structures
            const total = response.data?.total ??
                response.data?.data?.total ??
                (Array.isArray(response.data?.data) ? response.data.data.length : 0);

            if (typeof total === 'number' && total >= 0) {
                setFollowingCount(total);
            } else {
                console.warn("Following count not found in response or invalid format. Response:", response.data);
                setFollowingCount(0);
            }
        } catch (error) {
            console.error("Error fetching following count:", error);
            console.error("Error response:", error.response?.data);
            setFollowingCount(0);
        }
    };

    const fetchConnectionCount = async () => {
        if (!user_id) return;

        try {
            const response = await axios.get(`${BACKEND_URL}website/get-connections-list`, {
                params: {
                    login_user_id: 325,
                    user_id: user_id
                }
            });

            // Handle different possible response structures
            const total = response.data?.total ??
                response.data?.data?.total ??
                (Array.isArray(response.data?.data) ? response.data.data.length : 0);

            if (typeof total === 'number' && total >= 0) {
                setConnectionCount(total);
            } else {
                console.warn("Connection count not found in response or invalid format. Response:", response.data);
                setConnectionCount(0);
            }
        } catch (error) {
            console.error("Error fetching connection count:", error);
            console.error("Error response:", error.response?.data);
            setConnectionCount(0);
        }
    };

    // ACTION TYPE COLOR FOR THE ACTION TYPE
    const getActionTypeColor = (actionTypeId) => {
        switch (actionTypeId) {
            case 1: return "#1877F1";
            case 2: return "#7949FF";
            case 3: return "#0C00E8";
            case 4: return "#116C15";
            case 5: return "#04A676";
            case 6: return "#CA09FF";
            case 7: return "#FE0761";
            case 8: return "#FF17E8";
            case 9: return "#E80500";
            case 10: return "#FF7700";
            case 11: return "#03A5C9";
            case 12: return "#0A4A19";
            default: return "#1877F1";
        }
    };

    // Video initialization function
    const initializeVideo = (el, videoUrl, videoIndex) => {
        if (!el || !videoUrl || el.dataset.hlsInitialized) return;

        // Dynamically construct the proxy URL based on environment
        const backendBase = BACKEND_URL.replace('/api/', ''); // Get base URL without /api/

        // Extract just the filename from the video URL
        const filename = videoUrl.split('/').pop();

        // Construct the proxy URL dynamically
        const proxyUrl = `${backendBase}/video/${filename}`;

        console.log('Loading video from:', proxyUrl);

        const playMutedVideo = () => {
            el.muted = true;
            el.volume = 0;
            el.play().catch(err => console.log('Autoplay prevented:', err));
        };

        if (Hls.isSupported()) {
            const hls = new Hls({
                debug: false,
                enableWorker: true,
                lowLatencyMode: false,
                backBufferLength: 90,
                maxBufferLength: 30,
                maxMaxBufferLength: 60,
                maxBufferSize: 60 * 1000 * 1000,
                startLevel: 0,
                autoStartLoad: true,
                progressive: true,
                xhrSetup: function (xhr) {
                    xhr.withCredentials = false;
                    xhr.timeout = 10000;
                }
            });

            hls.loadSource(proxyUrl);
            hls.attachMedia(el);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                playMutedVideo();
            });

            hls.on(Hls.Events.ERROR, (event, data) => {
                console.error('HLS Error:', data);
                if (data.fatal) {
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            break;
                    }
                }
            });

            el.dataset.hlsInitialized = 'true';
            el.hlsInstance = hls;
        } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
            el.src = proxyUrl;
            playMutedVideo();
            el.dataset.hlsInitialized = 'true';
        } else {
            // Fallback for regular video files
            el.src = videoUrl;
            playMutedVideo();
        }

        el.dataset.videoIndex = videoIndex;
    };

    const toggleMute = () => {
        const newMuteState = !globalMute;
        setGlobalMute(newMuteState);

        // Apply to all videos
        document.querySelectorAll('video[data-video-index]').forEach(videoElement => {
            videoElement.muted = newMuteState;
            videoElement.volume = newMuteState ? 0 : 1;

            // Play video to allow sound (some browsers require this)
            if (!newMuteState) {
                videoElement.play().catch(err => console.log('Play failed after unmute:', err));
            }
        });
    };

    const sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        beforeChange: (current, next) => setActiveSlide(next),
    };

    // Fetch user posts
    const fetchUserPostList = async () => {
        try {
            if (!user_id) return;
            setPostsLoading(true);
            console.log("Fetching user posts for ID:", user_id);

            const response = await axios.post(`${BACKEND_URL}website/get-vendor-post-list`, {
                login_user_id: 501,
                user_id: user_id,
            });
            const data = response.data;
            setUserpostlist(data || []);
        } catch (error) {
            console.log("Error fetching user post list", error);
            setUserpostlist([]);
        } finally {
            setPostsLoading(false);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchuserdetails();
            fetchUserPostList();
            fetchFollowingCount();
            fetchConnectionCount();
        }
    }, [user_id]);

    // Intersection Observer for auto play/pause based on scroll
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video = entry.target;
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        // Video is 50% or more visible
                        video.play().catch(err => console.log('Play prevented:', err));
                    } else {
                        // Video is out of view
                        video.pause();
                    }
                });
            },
            {
                threshold: [0, 0.5, 1], // Trigger at 0%, 50%, and 100% visibility
                rootMargin: '0px'
            }
        );

        // Observe all video elements
        const videos = document.querySelectorAll('video[data-video-index]');
        videos.forEach(video => observer.observe(video));

        return () => {
            videos.forEach(video => observer.unobserve(video));
            observer.disconnect();
        };
    }, [userpostlist, globalMute]);


    // Shimmer Loading Component
    const ShimmerUserProfile = () => (
        <div className="user-main-layout">
            <LeftSection />
            <main className="user-middle-section">
                {/* User Profile Header Shimmer */}
                <div className="user-profile-wrapper">
                    <div className="shimmer-circle shimmer-profile-image"></div>
                    <div className="user-detail-wrapper">
                        <div className="shimmer-line shimmer-user-name"></div>
                        <div className="shimmer-line shimmer-user-designation"></div>
                        <div className="shimmer-line shimmer-user-location"></div>
                    </div>
                </div>

                {/* Buttons and Statistics Shimmer */}
                <div className="user-profile-button-wrapper">
                    <div className="user-profile-buttons">
                        <div className="shimmer-box shimmer-button"></div>
                        <div className="shimmer-box shimmer-button"></div>
                    </div>
                    <div className="user-profile-stats">
                        <div className="user-stat-item">
                            <div className="shimmer-line shimmer-stat-number"></div>
                            <div className="shimmer-line shimmer-stat-label"></div>
                        </div>
                        <div className="user-stat-divider"></div>
                        <div className="user-stat-item">
                            <div className="shimmer-line shimmer-stat-number"></div>
                            <div className="shimmer-line shimmer-stat-label"></div>
                        </div>
                        <div className="user-stat-divider"></div>
                        <div className="user-stat-item">
                            <div className="shimmer-line shimmer-stat-number"></div>
                            <div className="shimmer-line shimmer-stat-label"></div>
                        </div>
                    </div>
                </div>

                {/* Bio Shimmer */}
                <div className="user-bio-detail">
                    <div className="shimmer-line shimmer-bio-line"></div>
                    <div className="shimmer-line shimmer-bio-line"></div>
                    <div className="shimmer-line shimmer-bio-line-partial"></div>
                </div>

                {/* Tabs Shimmer */}
                <div className="user-tab-section">
                    <div className="shimmer-line shimmer-tab"></div>
                    <div className="shimmer-line shimmer-tab"></div>
                    <div className="shimmer-line shimmer-tab"></div>
                </div>

                {/* Posts List Shimmer */}
                <div className="user-profile-posts-list">
                    {[1, 2, 3].map((item) => (
                        <div key={item} className="shimmer-post-card">
                            <div className="shimmer-post-header">
                                <div className="shimmer-post-profile-info">
                                    <div className="shimmer-circle shimmer-post-avatar"></div>
                                    <div className="shimmer-post-user-info">
                                        <div className="shimmer-line shimmer-post-username"></div>
                                        <div className="shimmer-line shimmer-post-location"></div>
                                    </div>
                                </div>
                                <div className="shimmer-box shimmer-post-action-icon"></div>
                            </div>
                            <div className="shimmer-box shimmer-post-image"></div>
                            <div className="shimmer-post-actions">
                                <div className="shimmer-box shimmer-post-action-icon"></div>
                                <div className="shimmer-box shimmer-post-action-icon"></div>
                                <div className="shimmer-box shimmer-post-action-icon"></div>
                            </div>
                            <div className="shimmer-post-caption">
                                <div className="shimmer-line shimmer-post-caption-line"></div>
                                <div className="shimmer-line shimmer-post-caption-line-short"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );

    return (
        <div>
            <Navbar />
            {/* Mobile/Tablet Back Button Header */}
            <div className="user-profile-mobile-header">
                <img
                    src={leftarrow}
                    alt="back"
                    className="user-profile-back-arrow"
                    onClick={() => navigate(-1)}
                />
            </div>
            {loading ? (
                <ShimmerUserProfile />
            ) : (
                <div className="user-main-layout">
                    <LeftSection />
                    <main className="user-middle-section">
                        {userdetails.map((user, index) => (
                        <React.Fragment key={user.id || index}>

                            <div className="user-profile-wrapper">
                                {user.profile_image && user.profile_image.trim() !== "" ? (
                                    <img
                                        src={user.profile_image}
                                        alt={user.name}
                                        className="user-detail-profileimage"
                                    />
                                ) : (
                                    <div className="user-detail-profileimage user-profile-initial">
                                        {user.name ? user.name.charAt(0).toUpperCase() : "?"}
                                    </div>
                                )}

                                <div className="user-detail-wrapper">
                                    <h5 className="user-name">{user.name}</h5>
                                    <p className="user-designation">{user.designation}</p>

                                    {(user.state || user.country) && (
                                        <p className="user-location">
                                            {user.state && (
                                                <span className="user-state">{user.state}</span>
                                            )}
                                            {user.state && user.country && ", "}
                                            {user.country && (
                                                <span className="user-country">{user.country}</span>
                                            )}
                                        </p>
                                    )}
                                </div>
                            </div>

                            {/* Buttons and Statistics */}
                            <div className="user-profile-button-wrapper">
                                <div className="user-profile-buttons">
                                    <button className="connect-btn" onClick={() => setDownloadPopupOpen(true)}>Connect</button>
                                    <button className="message-btn" onClick={() => setDownloadPopupOpen(true)}>Message</button>
                                </div>
                                <div className="user-profile-stats">
                                    <div className="user-stat-item">
                                        <span className="user-stat-number">{userpostlist.length}</span>
                                        <span className="user-stat-label">Posts</span>
                                    </div>
                                    <div className="user-stat-divider"></div>
                                    <div className="user-stat-item">
                                        <span className="user-stat-number">{followingcount}</span>
                                        <span className="user-stat-label">Following</span>
                                    </div>
                                    <div className="user-stat-divider"></div>
                                    <div className="user-stat-item">
                                        <span className="user-stat-number">{connectioncount}</span>
                                        <span className="user-stat-label">Connections</span>
                                    </div>
                                </div>
                            </div>

                            {user.bio && (() => {
                                // Different limits for mobile and desktop
                                const bioLimit = isMobile ? 50 : 100;
                                const bioTruncateLength = isMobile ? 130 : 220;
                                const shouldTruncate = user.bio.length > bioTruncateLength;

                                return (
                                    <div className="user-bio-detail">
                                        <p className="user-bio-description">
                                            {showFullBio
                                                ? user.bio
                                                : shouldTruncate
                                                    ? `${user.bio.substring(0, bioTruncateLength)}... `
                                                    : user.bio
                                            }
                                            {shouldTruncate && (
                                                <span
                                                    className="more-link"
                                                    onClick={() => setShowFullBio(!showFullBio)}
                                                >
                                                    {showFullBio ? "Less" : "More"}
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                );
                            })()}
                        </React.Fragment>
                    ))}
                    {/* Tab Section */}
                    <div className="user-tab-section">
                        <button
                            className={`user-tab ${activeTab === "Posts" ? "active" : ""}`}
                            onClick={() => setActiveTab("Posts")}
                        >
                            Posts
                        </button>
                        <button
                            className={`user-tab ${activeTab === "Reviews" ? "active" : ""}`}
                            onClick={() => setActiveTab("Reviews")}
                        >
                            Reviews
                        </button>
                        <button
                            className={`user-tab ${activeTab === "Activities" ? "active" : ""}`}
                            onClick={() => setActiveTab("Activities")}
                        >
                            Activities
                        </button>
                    </div>

                    {/* Content Display */}
                    {activeTab === "Posts" && (
                        <>
                            {postsLoading ? (
                                <div className="user-profile-posts-list">
                                    {[1, 2, 3].map((item) => (
                                        <div key={item} className="shimmer-post-card">
                                            <div className="shimmer-post-header">
                                                <div className="shimmer-post-profile-info">
                                                    <div className="shimmer-circle shimmer-post-avatar"></div>
                                                    <div className="shimmer-post-user-info">
                                                        <div className="shimmer-line shimmer-post-username"></div>
                                                        <div className="shimmer-line shimmer-post-location"></div>
                                                    </div>
                                                </div>
                                                <div className="shimmer-box shimmer-post-action-icon"></div>
                                            </div>
                                            <div className="shimmer-box shimmer-post-image"></div>
                                            <div className="shimmer-post-actions">
                                                <div className="shimmer-box shimmer-post-action-icon"></div>
                                                <div className="shimmer-box shimmer-post-action-icon"></div>
                                                <div className="shimmer-box shimmer-post-action-icon"></div>
                                            </div>
                                            <div className="shimmer-post-caption">
                                                <div className="shimmer-line shimmer-post-caption-line"></div>
                                                <div className="shimmer-line shimmer-post-caption-line-short"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : userpostlist.length === 0 ? (
                                <div className="user-profile-nodata-message">
                                    <img
                                        src={nopost}
                                        className="user-profile-no-data-img"
                                        alt="no posts"
                                    />
                                    <p className="user-profile-no-data-p1">No posts found</p>
                                    <p className="user-profile-no-data-p2">Come back later to explore</p>
                                </div>
                            ) : (
                                <div className="user-profile-posts-list">
                                    {userpostlist.map((post, postIndex) => {
                                        // Check if this is a review-style post (user_type === "0" and view_type === 11 or 12)
                                        const isReviewPost = String(post.user_type) === "0" && (post.view_type === 11 || post.view_type === 12);
                                        const isReviewWithImage = String(post.user_type) === "0" && post.view_type === 12;
                                        // Check if this is a background image post (user_type === "0" and view_type === 13)
                                        const isBackgroundImagePost = String(post.user_type) === "0" && post.view_type === 13;

                                        return (
                                            <div key={post.id || postIndex} className={`feed-card ${isReviewPost ? 'review-card' : ''}`}>
                                                <div className="feed-header searchpage">
                                                    <div className="profile-info">
                                                        <Link to={`/userprofile/${post.user_id}`} className="remove-underline">
                                                            {post.user_image && post.user_image.trim() !== '' ? (
                                                                <img src={post.user_image} alt="feedcard1" />
                                                            ) : (
                                                                <div className="profile-initial">
                                                                    {post.user_name ? post.user_name.charAt(0).toUpperCase() : '?'}
                                                                </div>
                                                            )}
                                                        </Link>
                                                        <div className="hotelname">
                                                            <div className="business-name-and-category-name">
                                                                {String(post.user_type) === "0" ? (
                                                                    <>
                                                                        <Link to={`/userprofile/${post.user_id}`} className="remove-underline">
                                                                            <h4>{post.user_name}</h4>
                                                                        </Link>
                                                                        {/* Show "looking for" or "recommend" when data exists */}
                                                                        {(post.category_name || post.recommend_user) && (
                                                                            <>
                                                                                {/* For user_type "0", show only one: category_name OR recommend_user (not both) */}
                                                                                {post.category_name && post.category_name.trim() !== '' ? (
                                                                                    <span className="looking-for">
                                                                                        looking for <strong>{post.category_name}</strong>
                                                                                    </span>
                                                                                ) : post.recommend_user && post.recommend_user.user_name && post.recommend_user.user_name.trim() !== '' ? (
                                                                                    <span className="recommend-text">
                                                                                        recommend
                                                                                        <Link
                                                                                            to={`/vendordetails/${post.recommend_user.user_id || post.recommend_user.id}`}
                                                                                            className="remove-underline"
                                                                                        >
                                                                                            <strong>{post.recommend_user.user_name}</strong>
                                                                                        </Link>
                                                                                    </span>
                                                                                ) : null}
                                                                            </>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <Link to={`/userprofile/${post.user_id}`} className="remove-underline">
                                                                        <h4>{post.user_name}</h4>
                                                                        {/* Show "looking for" or "recommend" when data exists */}
                                                                        {(post.category_name || post.recommend_user) && (
                                                                            <>
                                                                                {/* For other user_types, show both if they exist */}
                                                                                {post.category_name && post.category_name.trim() !== '' && (
                                                                                    <span className="looking-for">
                                                                                        looking for <strong>{post.category_name}</strong>
                                                                                    </span>
                                                                                )}
                                                                                {post.recommend_user && post.recommend_user.user_name && post.recommend_user.user_name.trim() !== '' && (
                                                                                    <span className="recommend-text">
                                                                                        recommend <strong>{post.recommend_user.user_name}</strong>
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </Link>
                                                                )}
                                                            </div>
                                                            <p>
                                                                {String(post.user_type) === "0" && post.post_location
                                                                    ? post.post_location
                                                                    : post.state
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="header-actions">
                                                        {String(post.user_type) !== "0" && (
                                                            <p className="tag1">Follow</p>
                                                        )}
                                                        <div className="more-icon-container">
                                                            <img
                                                                src={threedot}
                                                                alt="threedot"
                                                                onClick={() => setDownloadPopupOpen(true)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Review-style content for user_type === "0" and view_type === 11 or 12 */}
                                                {isReviewPost ? (
                                                    <div className="review-content">
                                                        {isReviewWithImage ? (
                                                            /* view_type === 12: Show description on top, then image */
                                                            <>
                                                                {/* Only show description container if description exists */}
                                                                {post.description && post.description.trim() !== '' && (() => {
                                                                    // Mobile vs desktop limits
                                                                    const descLimit = isMobile ? 60 : 100;
                                                                    const descTruncateLength = isMobile ? 130 : 240;

                                                                    const shouldTruncate = post.description.length > descTruncateLength;
                                                                    const isExpanded = reviewExpand[post.id];

                                                                    return (
                                                                        <div className="review-description">
                                                                            <p className="user-profile-review-text">
                                                                                {isExpanded
                                                                                    ? post.description
                                                                                    : shouldTruncate
                                                                                        ? `${post.description.substring(0, descTruncateLength)}... `
                                                                                        : post.description
                                                                                }

                                                                                {shouldTruncate && (
                                                                                    <span
                                                                                        className="review-text-toggle"
                                                                                        onClick={() =>
                                                                                            setReviewExpand(prev => ({
                                                                                                ...prev,
                                                                                                [post.id]: !prev[post.id]
                                                                                            }))
                                                                                        }
                                                                                    >
                                                                                        {isExpanded ? "Less" : "More"}
                                                                                    </span>
                                                                                )}
                                                                            </p>
                                                                        </div>
                                                                    );
                                                                })()}

                                                                <div className="review-image">
                                                                    {post.post_images && (post.post_images.length > 0 && post.post_images[0].post_images) ? (
                                                                        <ReviewImageSlider
                                                                            post={post}
                                                                            activeSlide={activeSlide}
                                                                            sliderSettings={sliderSettings}
                                                                            coupons={post.coupons || []}
                                                                            categoryId={post.category_id}
                                                                        />
                                                                    ) : post.primary_image ? (
                                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                                            <img
                                                                                src={post.primary_image}
                                                                                alt={`Post ${post.id}`}
                                                                                className="review-image-content"
                                                                                style={{
                                                                                    maxWidth: '100%',
                                                                                    height: 'auto',
                                                                                    objectFit: 'contain'
                                                                                }}
                                                                            />
                                                                            {/* Coupon overlay for primary_image */}
                                                                            {post.coupons && post.coupons.length > 0 && (
                                                                                <div className="review-post-coupon-overlay-container">
                                                                                    {post.coupons.map((coupon, couponIdx) => (
                                                                                        <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={post.category_id} />
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            /* view_type === 11: Show description */
                                                            <>
                                                                {(post.description || translatedTexts[post.id]) && (() => {
                                                                    const textToShow =
                                                                        isTranslated[post.id] && translatedTexts[post.id]
                                                                            ? translatedTexts[post.id]
                                                                            : post.description;

                                                                    // Mobile vs desktop limits
                                                                    const descLimit = isMobile ? 60 : 100;
                                                                    const descTruncateLength = isMobile ? 100 : 240;

                                                                    const shouldTruncate = textToShow.length > descTruncateLength;
                                                                    const isExpanded = reviewExpand[post.id];

                                                                    return (
                                                                        <div className={`review-description ${isArabic(post.description) ? 'arabic-text' : ''}`}>
                                                                            <p
                                                                                className={`review-text ${isExpanded ? "expanded" : ""}`}
                                                                                dir={isArabic(post.description) && !isTranslated[post.id] ? "rtl" : "ltr"}
                                                                            >
                                                                                {isExpanded
                                                                                    ? textToShow
                                                                                    : shouldTruncate
                                                                                        ? `${textToShow.substring(0, descTruncateLength)}... `
                                                                                        : textToShow
                                                                                }

                                                                                {shouldTruncate && (
                                                                                    <span
                                                                                        className={`review-text-toggle ${isArabic(post.description) && !isTranslated[post.id]
                                                                                            ? 'review-text-toggle-right'
                                                                                            : 'review-text-toggle-left'
                                                                                            }`}
                                                                                        onClick={() =>
                                                                                            setReviewExpand(prev => ({
                                                                                                ...prev,
                                                                                                [post.id]: !prev[post.id]
                                                                                            }))
                                                                                        }
                                                                                    >
                                                                                        {isExpanded ? "Less" : "More"}
                                                                                    </span>
                                                                                )}
                                                                            </p>

                                                                            {/* Translation toggle */}
                                                                            {isArabic(post.description) && (
                                                                                <div className="review-translation-toggle">
                                                                                    {!isTranslated[post.id] && (
                                                                                        <>
                                                                                            {isTranslating[post.id] ? (
                                                                                                <span className="translation-loading">Translating...</span>
                                                                                            ) : (
                                                                                                <span
                                                                                                    className="translation-link"
                                                                                                    onClick={async () => {
                                                                                                        if (!translatedTexts[post.id]) {
                                                                                                            setIsTranslating(prev => ({
                                                                                                                ...prev,
                                                                                                                [post.id]: true
                                                                                                            }));

                                                                                                            try {
                                                                                                                const translated = await translateText(post.description, 'en');

                                                                                                                if (translated && translated.trim()) {
                                                                                                                    setTranslatedTexts(prev => ({
                                                                                                                        ...prev,
                                                                                                                        [post.id]: translated
                                                                                                                    }));
                                                                                                                    setIsTranslated(prev => ({
                                                                                                                        ...prev,
                                                                                                                        [post.id]: true
                                                                                                                    }));
                                                                                                                } else {
                                                                                                                    alert("Translation failed.");
                                                                                                                }
                                                                                                            } catch (err) {
                                                                                                                console.error(err);
                                                                                                                alert("Translation failed.");
                                                                                                            } finally {
                                                                                                                setIsTranslating(prev => ({
                                                                                                                    ...prev,
                                                                                                                    [post.id]: false
                                                                                                                }));
                                                                                                            }
                                                                                                        } else {
                                                                                                            setIsTranslated(prev => ({
                                                                                                                ...prev,
                                                                                                                [post.id]: true
                                                                                                            }));
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    See Translation
                                                                                                </span>
                                                                                            )}
                                                                                        </>
                                                                                    )}

                                                                                    {isTranslated[post.id] && translatedTexts[post.id] && (
                                                                                        <span
                                                                                            className="translation-link translation-link-original"
                                                                                            onClick={() =>
                                                                                                setIsTranslated(prev => ({
                                                                                                    ...prev,
                                                                                                    [post.id]: false
                                                                                                }))
                                                                                            }
                                                                                        >
                                                                                            See Original
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })()}

                                                                {/* Coupons below description for view_type 11 */}
                                                                {post.coupons && post.coupons.length > 0 && (
                                                                    <div className="review-post-coupon-cards-container">
                                                                        {post.coupons.map((coupon, couponIdx) => (
                                                                            <CouponCard key={couponIdx} coupon={coupon} isOverlay={false} categoryId={post.category_id} />
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                ) : null}

                                                {/* Background image post for user_type === "0" and view_type === 13 */}
                                                {isBackgroundImagePost ? (
                                                    <div
                                                        className="background-image-post"
                                                        style={{
                                                            backgroundImage: post.background_image ? `url(${post.background_image})` : 'none',
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat',
                                                            minHeight: '400px',
                                                            position: 'relative',
                                                            width: '100%',
                                                            aspectRatio: '1 / 1',
                                                            overflow: 'hidden'
                                                        }}
                                                    >
                                                        {(post.description || post.background_image_title) && (
                                                            <div
                                                                className="background-image-content"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    color: post.background_image_title_color || 'black',
                                                                    textAlign: 'center',
                                                                    padding: '20px',
                                                                    zIndex: 2,
                                                                    width: '90%',
                                                                    maxWidth: '100%'
                                                                }}
                                                            >
                                                                {post.background_image_title && (
                                                                    <h3 style={{
                                                                        margin: '0 0 10px 0',
                                                                        color: post.background_image_title_color || 'black',
                                                                        fontSize: '24px',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        {post.background_image_title}
                                                                    </h3>
                                                                )}
                                                                {post.description && (
                                                                    <p style={{
                                                                        margin: 0,
                                                                        color: post.background_image_title_color || 'black',
                                                                        fontSize: '18px',
                                                                        fontWeight: '500',
                                                                        wordWrap: 'break-word'
                                                                    }}>
                                                                        {post.description}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : null}

                                                {/* Only show media for non-review posts and non-background image posts */}
                                                {!isReviewPost && !isBackgroundImagePost && (
                                                    <FeedMediaContent
                                                        post={post}
                                                        index={postIndex}
                                                        activeSlide={activeSlide}
                                                        sliderSettings={sliderSettings}
                                                        initializeVideo={(el, videoUrl) => initializeVideo(el, videoUrl, postIndex)}
                                                        globalMute={globalMute}
                                                        toggleMute={toggleMute}
                                                        videomute={videomute}
                                                        videounmute={videounmute}
                                                        getActionTypeColor={getActionTypeColor}
                                                        showFullSlider={false}
                                                        isVendorDetails={true}
                                                    />
                                                )}

                                                <div className="post-content-text">
                                                    <div className="feed-actions">
                                                        <div className="left-icons">
                                                            <img src={hearticon} alt="heart icon" className="heart"  onClick={() => setDownloadPopupOpen(true)}/>
                                                            <span>{post.likes > 0 ? post.likes : ''}</span>
                                                            <p className="post-vertical-line">|</p>
                                                            <img src={commenticon} alt="comment icon" className="comment"  onClick={() => setDownloadPopupOpen(true)} />
                                                            <span>{post.comments_count > 0 ? post.comments_count : ''}</span>
                                                            <p className="post-vertical-line">|</p>
                                                            <img src={shareicon} alt="share icon" className="shareicon"  onClick={() => setDownloadPopupOpen(true)} />
                                                            <span></span>
                                                        </div>
                                                        <img src={save} alt="save" id="save"  onClick={() => setDownloadPopupOpen(true)} />
                                                    </div>

                                                    {/* Show description for non-review posts, or timestamp for review posts */}
                                                    {isReviewPost ? (
                                                        <div className="review-timestamp">
                                                        </div>
                                                    ) : !isBackgroundImagePost ? (
                                                        <div className="feed-caption">
                                                            <p
                                                                className={`feed-caption-text ${expand[post.id] ? "expanded" : ""}`}
                                                            >
                                                                {post.description}
                                                            </p>
                                                            {post.description?.length > 120 && (
                                                                <span
                                                                    className="feed-caption-toggle"
                                                                    onClick={() => setExpand({ ...expand, [post.id]: !expand[post.id] })}
                                                                >
                                                                    {expand[post.id] ? "Less" : "More"}
                                                                </span>
                                                            )}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </>
                    )}

                    {/* Reviews Tab Content */}
                    {activeTab === "Reviews" && (
                        <>
                            {userreviewslist.length === 0 ? (
                                <div className="user-profile-nodata-message">
                                    <img
                                        src={noreviews}
                                        className="user-profile-no-reviews-img"
                                        alt="no reviews"
                                    />
                                    <p className="user-profile-no-reviews-p1">No reviews yet</p>
                                    <p className="user-profile-no-reviews-p2">Come back later to explore</p>
                                </div>
                            ) : (
                                <div className="user-profile-reviews-list">
                                    {/* Reviews content will go here when implemented */}
                                </div>
                            )}
                        </>
                    )}

                    {/* Activities Tab Content */}
                    {activeTab === "Activities" && (
                        <>
                            {useractivitieslist.length === 0 ? (
                                <div className="user-profile-nodata-message">
                                    <img
                                        src={noactivities}
                                        className="user-profile-no-activities-img"
                                        alt="no activities"
                                    />
                                    <p className="user-profile-no-activities-p1">No activities yet</p>
                                    <p className="user-profile-no-activities-p2">Come back later to explore</p>
                                </div>
                            ) : (
                                <div className="user-profile-activities-list">
                                    {/* Activities content will go here when implemented */}
                                </div>
                            )}
                        </>
                    )}
                </main>





                <aside className="right-section user-profile-page">
                    {/* Download App section */}
                    {/* <div className="download-app">
                        <div className="hayaticon">
                            <img src={hayatlogo} alt="Hayat In Logo" />
                            <a href="#close" className="close-btn">
                                <img src={xmark} alt="xmark" className="xmark" />
                            </a>
                        </div>
                        <h4>Download Hayat In App</h4>

                        <div className="store-buttons">
                            <div className="app_qr">
                                <a
                                    href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={app_store} alt="App Store" />
                                </a>

                                <a
                                    href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={play_store} alt="Google Play" />
                                </a>
                            </div>


                            <div className="app_qr">
                                <img className="qr" src={qr} alt="QR code" />
                            </div>
                        </div>
                    </div> */}

                    {/* Trending Section */}
                    {/* <div className="trending-section">
                                        <h3>Trending<span id="rightarrow"><img id="rightarrow-img" src={rightarrow} alt="rightarrow" /></span></h3>
                
                                        <div className="trend-card">
                                            <img src={hotel1} alt="hotel1" />
                                            <div className="trend-info">
                                                <h4>Dubai Desert Safari</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel2} alt="hotel2" />
                                            <div className="trend-info">
                                                <h4>Balcon Bar Restaurant</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel3} alt="hotel3" />
                                            <div className="trend-info">
                                                <h4>Nujum Desert Camp</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel2} alt="hotel2" />
                                            <div className="trend-info">
                                                <h4>Balcon Bar Restaurant</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel3} alt="hotel3" />
                                            <div className="trend-info">
                                                <h4>Nujum Desert Camp</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel3} alt="hotel3" />
                                            <div className="trend-info">
                                                <h4>Nujum Desert Camp</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel2} alt="hotel2" />
                                            <div className="trend-info">
                                                <h4>Balcon Bar Restaurant</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                
                                    </div> */}

                    {/* Connections Section  */}
                    {/* <div className="connections-section">
                                        <div className="connections-header">
                                            <h3>Connections<span id="rightarrow"><img id="rightarrow-img" src={rightarrow} alt="rightarrow" /></span></h3>
                                        </div>
                
                                        <div className="connection-card">
                                            <img src={pic1} alt="pic1" />
                                            <p>Najm Al-Barq</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic2} alt="pic2" />
                                            <p>Lina</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic3} alt="pic3" />
                                            <p>Amal Zakariya</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic4} alt="pic4" />
                                            <p>Khalid Ayman</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic5} alt="pic5" />
                                            <p>Muhamed Rayan</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic6} alt="pic6" />
                                            <p>Amal Nour Bin</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                
                                    </div> */}
                </aside>
                </div>
            )}

            {downloadPopupOpen && (
                <>
                    <div className="overlay" onClick={() => setDownloadPopupOpen(false)}></div>
                    <div className="download-popup-drawer">
                        <div className="pop-up-img">
                            <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                        </div>
                        <div className="popup-header">
                            <div className="pop-up-download">
                                <div className="hayaticon">
                                    <img src={hayatlogo} alt="Hayat In Logo" />
                                    <div className="close-btn">
                                        <img src={xmark} alt="xmark" className="close-popup" onClick={() => setDownloadPopupOpen(false)} />
                                    </div>
                                </div>
                                <h4 className="download-hayat">Download Our App </h4>
                                <p id="App-description">
                                    Scan the QR code with your phone and open Hayat In instantly
                                    Your gateway to discovering the city in one tap.
                                </p>

                                <div className="store-buttons">
                                    <div className="app_qr">
                                        <a
                                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={app_store} alt="App Store" />
                                        </a>

                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={play_store} alt="Google Play" />
                                        </a>
                                    </div>


                                    <div className="app_qr">
                                        <img className="qr" src={qr} alt="QR code" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default UserProfile